// @flow
import { makeGetRequest } from './utils'

import type { ResponseAPI } from './types/api'
import type { ServiceProvider } from './types/serviceProvider'

export const getServiceProvider = (domain: string): Promise<ResponseAPI<ServiceProvider>> =>
  makeGetRequest(`${domain}/client/api/service-provider`)
